import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./faleConosco.css";
import WhatsAppIcon from "../../img/icons/Whats.svg";

export default function FaleConosco() {
  const [form, setForm] = useState({ nome: "", email: "", mensagem: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_3z91k3f", // seu service_id
        "template_jprh0do", // seu template_id
        {
          from_name: form.nome,
          from_email: form.email,
          message: form.mensagem,
        },
        "l8lRvITtaTebSgmF0" // sua public_key
      )
      .then(
        () => {
          alert("Mensagem enviada com sucesso!");
          setForm({ nome: "", email: "", mensagem: "" });
        },
        (error) => {
          alert("Ocorreu um erro ao enviar a mensagem. Tente novamente.");
          console.error("Erro ao enviar e-mail:", error);
        }
      );
  };

  const whatsappNumber = "5511970874083";


  // Mensagem personalizada
  const mensagem = encodeURIComponent(
    `Olá! vim pelo site do DK Coworking.`
  );

  // Link do WhatsApp
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${mensagem}`;

  return (
    <section id="contato" className="fale-conosco">
      <h1 className="fale-conosco__titulo">Fale conosco</h1>

      <div className="fale-conosco__container">
        <form className="fale-conosco__form" onSubmit={handleSubmit}>
          <label>
            Nome:
            <input
              type="text"
              name="nome"
              value={form.nome}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            E-Mail:
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Mensagem:
            <textarea
              name="mensagem"
              value={form.mensagem}
              onChange={handleChange}
              rows="5"
              required
            />
          </label>

          <button type="submit" className="fale-conosco__botao">
            ENVIAR
          </button>
        </form>

        {/* Ícone flutuante do WhatsApp */}
        <a
          href= {whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="fale-conosco__whatsapp"
        >
          <img src={WhatsAppIcon} alt="WhatsApp" className="whatsapp-icon" />
        </a>
      </div>
    </section>
  );
}
